import React from 'react'
import injectSheet from 'react-jss'
import styles from './action-conclusion.styles'
import CheckIcon from 'react-icons/lib/fa/check'

const ActionConclusion = ({ classes, id, name, timestamp }) => {
  return (
    <div className={classes.container}>
      <span className={classes.icon}>
        <CheckIcon />
      </span>{' '}
      <div>
        <strong className={classes.name}>{name}</strong>&nbsp;selected a
        conclusion {timestamp} ago
      </div>
    </div>
  )
}

export default injectSheet(styles)(ActionConclusion)
